import { action, computed, observable } from 'mobx';

import { HostMap, Schedule } from 'services/pangolin/types';

import { SearchInputStore } from 'ui/standard/input/search_input/search_input_store';

import {
  ALL_DEVICES,
  DeviceEntry,
  HostDeviceEntry,
  createDeviceEntries,
} from 'ui/schedules/device_entry/device_entry_logic';

export class DeviceInputStore {
  search: SearchInputStore;
  @observable.shallow entries: DeviceEntry[];

  constructor(schedule: Schedule, hosts: HostMap) {
    this.search = new SearchInputStore();
    this.entries = createDeviceEntries(schedule, hosts);
  }

  @action.bound
  commitEntry(entry: DeviceEntry): void {
    this.entries.push(entry);
  }

  @action.bound
  removeEntry(entry: DeviceEntry): void {
    const finder = entry.kind === ALL_DEVICES ?
      ((e: DeviceEntry) => e.kind === ALL_DEVICES) :
      ((e: DeviceEntry) => e.kind !== ALL_DEVICES && e.host.id === entry.host.id);
    const index = this.entries.findIndex(finder);
    if (index >= 0) {
      this.entries.splice(index, 1);
    }
  }

  @computed get hasAllDevices(): boolean {
    return this.entries.some((x) => x.kind === ALL_DEVICES);
  }

  @computed get hostIDs(): string[] {
    return this.entries.filter(isHostDeviceEntry).map((entry) => entry.host.id);
  }
}

export function isHostDeviceEntry(x: DeviceEntry): x is HostDeviceEntry {
  return x.kind !== ALL_DEVICES;
}
